import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';
import BlankState from '../../../components/BlankState';
import Modal from '../../../components/Modal';
import BranchesForm from './BranchesForm';

import { listBranches, listRegions, saveBranch, updateBranch } from '../../../../src/actions/branches';
import { getInsurers } from '../../../../src/utils/apiService';



class Branches extends Component{

	constructor(props){
		super(props);

		this.state = {
            branches: [],
            regions: [],
            insurers: [],
            branches_loading: true,
            active_branch: {},
            filter:{
                insurer:'',
            },
        };
        
    }

    onChange1 = (e) => {
		const { name, value } = e.target;

        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value
            }
        }, ()=>{
            this.listFilteredBranches();
            this.getInsurersList();
		});
    }
    listFilteredBranches(){
        const { listBranches }=this.props;
        listBranches(this.state.filter.insurer);
    }
    editBranches(branch) {
        this.setState({ active_branch: branch })
    }
    
    componentDidMount(){
        const { listBranches, listRegions, user } = this.props;
        const insurer = user.userInfo.insurer;
        
        listBranches(insurer)
        listRegions(insurer);
        this.getInsurersList();
            
    }
    getInsurersList(){
        getInsurers()
        .then((response)=>{
            this.setState({ insurers: response.data, branches_loading: false })
        })
        .catch((error)=>{
            this.setState({ branches_loading: false })
        });}

    onChange = (e) => {
        e.preventDefault();

        const { branch } = this.state;
        const { name, value } = e.target;

        this.setState({ 
            branch: {
                ...branch,
                [name]: value
            }
         });
        
    }
    onUpdateBranch = (e) => {
        e.preventDefault()
        
            const { active_branch, branch } = this.state;
           
    
            const updatedBranch = {
                id: active_branch.id,
                insurer: branch.insurer,
                name: branch.branch_name,
                code: branch.branch_code,
                region: branch.branch_region,
                location: branch.branch_location,
                email: branch.email,
                phone: branch.phone
            };
            if(updatedBranch){
                this.props.updateBranch(updatedBranch);
            }
           
        }
      
	render(){
       
        
        
        const  user_role = this.props.user.userInfo.roles ;
		const menuItems = [
			{ id: "all-branches", name: "All Branches", active: true },
            user_role.includes('insurer_admin') ?  { id: "add-branch", name: "Add Branch" } : ""
        ]
        
        let { active_branch, branches_loading, insurers } = this.state;
        let { branches } = this.props;
       

		return(
			<Page isAdminPage={ true } pageTitle="Branches">
				<div className="clearfix">
					<TabHolder menuItems={ menuItems }>
						
						<Tab menuId={ menuItems[0].id } isActive={ true }>
                        {
                            insurers.length > 0 ?
                            <div 
                            className="clearfix form form-inline" 
                            style={{ marginBottom: "2em" }}>
                            {
                             !user_role.includes('insurer_admin') ?
                                <select className="form-control" onChange={this.onChange1} name="insurer" required>
                                <option value="">All Insurers</option>
                                {
                                    insurers.map((insurers, index) => {
                                            return (
                                                <option key={index} value={insurers.id}>
                                                    {insurers.company_name}
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                                :null
                                }
                            </div>
                            :null

                        }
                        {
                            branches.branches.length > 0 ?
                        
                            <DataTable 
                                tableId="branches-table"
                                columnTitles={ ["Name", "Region", "Location", "Email", "Helpline","Insurer", "Actions"] }>
                            {
                                 branches.branches.map(branch => {
                                    return (
                                        <tr key={ branch.id }>
                                            <td>{branch.branch_name}</td>
                                            <td>{branch.region_name}</td>
                                            <td>{branch.branch_location}</td>
                                            <td>{branch.email}</td>
                                            <td>{branch.phone}</td>
                                            <td>{branch.insurer_name}</td>
                                            <td>
                                                <button
                                                    data-toggle="modal" 
                                                    data-target=".edit-branch-modal"
                                                    className="btn btn-warning btn-sm"
                                                    onClick={ ()=>{ this.editBranches(branch) } }>
                                                    Edit
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                                    }
                                </DataTable>
                            :
                                    <BlankState 
                                    data={ branches.branches } 
                                    dataName="Branches" 
                                    isDataLoading={ branches_loading } />
                        }
                        
                            <Modal 
                                title="Edit Branch"
                                className="edit-branch-modal"
                                closable={ true }>

                                  <BranchesForm edit={ true } branch={ active_branch } />

                            </Modal>
                        </Tab>
						<Tab menuId={ menuItems[1].id }>
                            <div className="col-md-6">
                                <BranchesForm />
                             </div>
                          
						</Tab>
					</TabHolder>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    branches: state.branches,
    regions: state.regions,
    insurers: state.insurers

});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listBranches, listRegions, updateBranch, saveBranch }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Branches);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/Branches.jsx